import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import imageDetailList from './imageDetailList.vue';
import birthGiftVos from './giftTbale.vue';
import pointsProduct from './pointsProduct.vue';
import SalesArea from './area_select.vue';
import signRules from './signRules.vue';
import newUserAcquisitionRules from './new_user_acquisition_rules.vue';
import IntegralRule from './IntegralRule.vue';

formCreate.component('SalesArea', SalesArea);
formCreate.component('imageDetailList', imageDetailList);
formCreate.component('pointsProduct', pointsProduct);
formCreate.component('signRules', signRules);
formCreate.component('newUserAcquisitionRules', newUserAcquisitionRules);
formCreate.component('IntegralRule', IntegralRule);
formCreate.component('birthGiftVos', birthGiftVos);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      // rule: [],
      formFunctionCode: 'add_form',
      memberActivityType: '1',
    };
  },
  methods: {

    // 设置规则
    setRule(item) {
      if (item.field === 'listOfActivitiesUrl') {
        item.props = {
          ...item.props,
          limit: 1,
        };
      }
      if (item.field === 'activitiesRuleUrl') {
        item.props = {
          ...item.props,
          limit: 1,
        };
      }
      if (item.field === 'activitiesUrl') {
        item.props = {
          ...item.props,
          limit: 1,
        };
      }
      if (item.field === 'startTime') {
        item.props = {
          ...item.props,
          type: 'datetime',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          defaultTime: '00:00:00',
        };
      }
      if (item.field === 'endTime') {
        item.props = {
          ...item.props,
          type: 'datetime',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          defaultTime: '23:59:59',
        };
      }
      if (item.field === 'memberActivityType') {
        item.on = {
          ...item.on,
          change: (e) => {
            this.onChangeType(e);
            this.clearData();
          },
        };
      }
      if (item.field === 'typesOfDailyAtivities') {
        item.on = {
          ...item.on,
          change: (e) => {
            this.onChangeActivtry(e);
            this.clearData();
          },
        };
      }
      item.props = {
        ...item.props,
        fApi: this.fApi,
      };
      return item;
    },
    // 日常活动变化
    /* eslint-disable no-param-reassign */
    onChangeActivtry(e) {
      e = this.fApi.getValue('typesOfDailyAtivities') || e;
      if (e === '1') {
        this.hiddenFields(false, ['detailedPicture', 'signRules', 'regionList', '1', '4', '3']);
        this.hiddenFields(true, ['productList', 'obtainNewcomerList', '2', '5', 'integralRuleList', '6', 'birthGiftVos', '7']);
      }
      if (e === '2') {
        this.hiddenFields(false, ['obtainNewcomerList', 'detailedPicture', 'regionList', '1', '5', '3']);
        this.hiddenFields(true, ['productList', 'signRules', '2', '4', 'integralRuleList', '6', 'birthGiftVos', '7']);
      }
      if (e === '3') {
        this.hiddenFields(false, ['integralRuleList', 'detailedPicture', 'regionList', '1', '6', '3']);
        this.hiddenFields(true, ['productList', 'signRules', '2', '4', 'obtainNewcomerList', '5', 'birthGiftVos', '7']);
      }
      if (e === '4') {
        this.hiddenFields(false, ['integralRuleList', 'detailedPicture', 'regionList', '1', '6', '3', 'birthGiftVos', '7']);
        this.hiddenFields(true, ['productList', 'signRules', '2', '4', 'obtainNewcomerList', '5']);
      }
    },
    /* eslint-enable no-param-reassign */
    // 类型变化
    /* eslint-disable no-param-reassign */
    onChangeType(e) {
      e = this.fApi.getValue('memberActivityType') || e;
      console.log('eeee', e);
      this.memberActivityType = e;
      const detailedPicture = this.getRule('detailedPicture');
      detailedPicture.props.memberActivityType = e;
      if (e === '1') {
        this.hiddenFields(false, ['detailedPicture', 'productList', 'regionList', '1', '2', '3']);
        this.hiddenFields(true, ['typesOfDailyAtivities', 'signRules', '4', 'obtainNewcomerList', '5', 'integralRuleList', '6', 'birthGiftVos', '7']);
      }
      if (e === '2') {
        this.hiddenFields(false, ['detailedPicture', 'regionList', '1', '3']);
        this.hiddenFields(true, ['productList', '2', 'signRules', '4', 'obtainNewcomerList', '5', 'integralRuleList', 'birthGiftVos', '7']);
      }
      if (e === '3') {
        this.hiddenFields(false, ['typesOfDailyAtivities']);
        this.hiddenFields(true, ['birthGiftVos', '7']);
        this.onChangeActivtry();
      }
      if (e === '4') {
        this.hiddenFields(true, ['typesOfDailyAtivities', 'productList', '2', 'signRules', '4', '6', 'integralRuleList', '5', 'obtainNewcomerList']);
        this.hiddenFields(false, ['birthGiftVos', '7']);
      }
    },
    /* eslint-enable no-param-reassign */
    // 活动切换后清空数据
    clearData() {
      this.setValue({
        detailedPicture: [],
        productList: [],
        regionList: [],
        signRules: [],
        obtainNewcomerList: [],
        integralRuleList: [],
        birthGiftVos: [],
      });
    },

    // 渲染完成后执行
    formComplete() {
      const { code, row } = this.formConfig;
      if (code === 'add') {
        this.fApi.hidden(true, ['4', 'signRules', '5', 'obtainNewcomerList', '6', 'integralRuleList', 'birthGiftVos', '7']);
      }
      if (code === 'edit' || code === 'view') {
        request.get('/cps/v1/memberActivityInfo/memberActivityInfo/findById', { id: row.id }).then((res) => {
          if (res.success) {
            const { result } = res;
            this.setValue({ ...result });
            this.onChangeType(result.memberActivityType);
            this.onChangeActivtry(result.typesOfDailyAtivities);
          }
        });
      }
    },
    // 提交
    submit() {
      let formData = this.getFormData(); // 获取表单的值
      console.log('formData111', formData);
      if (formData) {
        formData = {
          ...formData,
        };
        // 默认新增
        let url = '/cps/v1/memberActivityInfo/memberActivityInfo';
        console.log(this.formConfig.row);
        // 有id  就是编辑
        if (this.formConfig.row.id) {
          formData.id = this.formConfig.row.id;
          formData.memberActivityCode = this.formConfig.row.memberActivityCode;
          url = '/cps/v1/memberActivityInfo/memberActivityInfo/update';
        }
        request.post(url, formData).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
